import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { concatMap } from 'rxjs/operators';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { CompanyResponse, PaginationCompanyResponse } from 'src/app/models/company.model';
import { PaginationModel, SimplePaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { PaginationPartnerResponse, PartnerResponse } from 'src/app/models/user.model';
import { AssociateCompanyService } from 'src/app/services/associate.service';
import { CompanyService } from 'src/app/services/company.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-partners-not-associated',
  templateUrl: './partners-not-associated.component.html',
  styleUrls: ['./partners-not-associated.component.scss']
})
export class PartnersNotAssociatedComponent implements OnInit {
  paginationCompanies = new SimplePaginationModel(0, 5, 0, 0, 0);
  companies: CompanyResponse[] = [];
  partners: PartnerResponse[] = [];
  queueDelete = null;
  deleting: { [key: number]: any } = {};
  showModalCreate = false;
  failedStart = false;
  paginationPartners = new SimplePaginationModel(0, 5, 0, 0, 0);
  filterCompanies = "";
  filterPartners = "";
  partnerId: string | null = null;
  companyId: string | null = null;
  buttonAssociate: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");

  @ViewChild('svgContainer', { static: true }) svgContainer: ElementRef;
  @HostListener('window:resize', ['$event'])

  onResize(event: Event) {
    this.drawLink();
  }

  constructor(
    private toastService: ToastrService,
    private associateService: AssociateCompanyService,
    private userService: UserService,
    private companyService: CompanyService
  ) {

  }

  ngOnInit(): void {
    this.getStartData();
  }

  getCompaniesAssociated(partner: PartnerResponse) {
    partner.loading = partner.companies.length == 0;
    partner.showCompany = !partner.showCompany;
    if (partner.showCompany && partner.companies.length == 0) {
      this.companyService.getCompaniesAssociatedToPartner(
        partner.id
      ).subscribe({
        next: (response: ResponseObject) => {
          partner.companies = response.data as CompanyResponse[];
          partner.loading = false;
        },
        error: (error: HttpErrorResponse) => {
          partner.loading = false;
          this.toastService.error(error.error.message);
        }
      })
    }
  }

  selectRow(table: string, row: string) {
    if (table === 'table-partners') {
      this.partnerId = row;
    } else if (table === 'table-no-associated') {
      this.companyId = row;
    }
    this.drawLink();
  }

  drawLink() {
    if (this.partnerId && this.companyId) {
      setTimeout(() => {
        const svg = this.svgContainer.nativeElement as SVGElement;
        svg.innerHTML = ''; // Clear previous lines

        const table1Row = document.querySelector(`#table-partners tr.selected`);
        const table2Row = document.querySelector(`#table-no-associated tr.selected`);

        if (table1Row && table2Row) {
          const rect1 = table1Row.getBoundingClientRect();
          const rect2 = table2Row.getBoundingClientRect();

          const parentRect = svg.parentElement.getBoundingClientRect();

          const x1 = rect1.right - parentRect.left - 12;
          const y1 = rect1.top + rect1.height / 2 - parentRect.top;
          const x2 = rect2.left - parentRect.left - 12;
          const y2 = rect2.top + rect2.height / 2 - parentRect.top;
          const xMiddle = x1 + ((x2 - x1) / 2);

          this.drawLine(svg, x1, xMiddle, y1, y1);
          this.drawLine(svg, xMiddle, x2, y2, y2);
          this.drawLine(svg, xMiddle, xMiddle, y1, y2);
        }
      }, 50);
    } else {
      const svg = this.svgContainer.nativeElement as SVGElement;
      svg.innerHTML = ''; // Clear previous lines
    }
  }

  drawLine(svg, x1, x2, y1, y2) {
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', x1.toString());
    line.setAttribute('y1', y1.toString());
    line.setAttribute('x2', x2.toString());
    line.setAttribute('y2', y2.toString());
    line.setAttribute('stroke', '#001f54');
    line.setAttribute('stroke-width', '2');
    svg.appendChild(line);
  }

  closeModalCreate(created) {
    if (created) {
      this.getStartData();
    }
    this.showModalCreate = false;
  }

  deleteAssociate(company:CompanyResponse) {
    if (this.deleting[company.id]) {
      return;
    }
    this.deleting[company.id] = true;
    this.companyService.deleteAssociation(
      company.id
    ).subscribe({
      next: (response:ResponseObject) => {
        this.toastService.success("Se ha eliminado la asociación con la empresa");
        this.deleting[company.id] = false;
        this.getStartData();
      },
      error: (error: HttpErrorResponse) => {
        this.deleting[company.id] = false;
        this.toastService.error(error.error.message);
      }
    })
  }

  confirmDelete(associate) {
    if (this.deleting[associate.id]) {
      return;
    }
    var temp = associate;
    this.queueDelete = null;
    this.deleting[associate.id] = true;
    setTimeout(() => {
      this.deleting[associate.id] = false;
    }, 1000);
  }

  refresh(pagination) {
    pagination.startElement = pagination.pageIndex * pagination.pageSize;
    var temporalLast = pagination.startElement + pagination.pageSize;
    pagination.lastElement = (temporalLast < pagination.total.length) ? temporalLast : pagination.total.length;
    pagination.filter = pagination.total.slice(pagination.startElement, pagination.lastElement);
  }

  timeoutPartner = null;
  writePartner() {
    clearTimeout(this.timeoutPartner);
    this.timeoutPartner = setTimeout(() => {
      this.paginationPartners = new SimplePaginationModel(0, 5, 0, 0, 0);
      this.getPartners();
    }, 200);
  }

  timeoutCompany = null;
  writeCompany() {
    clearTimeout(this.timeoutCompany);
    this.timeoutCompany = setTimeout(() => {
      this.paginationCompanies = new SimplePaginationModel(0, 5, 0, 0, 0);
      this.getCompaniesNoAssociated();
    }, 200);
  }

  getCompaniesNoAssociated() {
    this.drawLink();
    this.companyService.getPaginationCompaniesNoAssociated(
      this.filterCompanies,
      this.paginationCompanies.page,
      this.paginationCompanies.size
    ).subscribe({
      next: (response: ResponseObject) => {
        var temp = response.data as PaginationCompanyResponse;
        this.paginationCompanies.total = temp.total;
        this.companies = temp.companies;
        this.paginationCompanies.start = this.paginationCompanies.page * this.paginationCompanies.size + 1;
        this.paginationCompanies.end = this.paginationCompanies.start + this.companies.length - 1;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getPartners() {
    this.drawLink();
    this.userService.getPartners(
      this.filterPartners,
      this.paginationPartners.page,
      this.paginationPartners.size
    ).subscribe({
      next: (response: ResponseObject) => {
        var tempPartner = response.data as PaginationPartnerResponse;
        this.partners = tempPartner.partners;
        this.partners.forEach((p)=>{
          p.companies = [];
        })
        this.paginationPartners.total = tempPartner.total;
        this.paginationPartners.start = this.paginationPartners.page * this.paginationPartners.size + 1;
        this.paginationPartners.end = this.paginationPartners.start + this.partners.length - 1;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }


  getStartData() {
    this.getCompaniesNoAssociated();
    this.getPartners();
  }

  associateToPartner() {
    if (this.buttonAssociate.loading || !this.companyId || !this.partnerId) {
      return;
    }
    this.buttonAssociate.loading = true;
    this.companyService.associateToPartner(
      parseInt(this.companyId),
      parseInt(this.partnerId)
    ).subscribe(
      {
        next: (response: ResponseObject) => {
          this.buttonAssociate.loading = false;
          this.toastService.success("Empresa asociada correctamente!");
          this.companyId = null;
          this.getStartData();
        },
        error: (error: HttpErrorResponse) => {
          this.buttonAssociate.loading = false;
          this.toastService.error(error.error.message);
        }
      }
    )
  }
}
